import './globals';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { pinia } from './stores/pinia';
import Amplify from 'aws-amplify';
import vuetify from './plugins/vuetify';
import VueGtag, { type PluginOptions } from 'vue-gtag';
import DbEnum from './enums/DbEnum';
import AppEnum from './enums/AppEnum';
import ValidationHelper from './helpers/ValidationHelper';
import BaseHelper from './helpers/BaseHelper';
import EnumHelper from './helpers/EnumHelper';
import DateHelper from './helpers/DateHelper';
import config from './config/config';
import StoreHelper from './helpers/StoreHelper';
import './assets/design/css/Common.css';
import './assets/fonts/fonts.scss';

Amplify.configure(config.amplifyConfig);

const app = createApp(App);

app.config.globalProperties.$dbEnum = DbEnum;
app.config.globalProperties.$appEnum = AppEnum;
app.config.globalProperties.$v = ValidationHelper.getInstance();
app.config.globalProperties.$enumHelper = EnumHelper.getInstance();
app.config.globalProperties.$date = DateHelper.getInstance();
app.config.globalProperties.$handleErrors = BaseHelper.handleErrors;
app.config.globalProperties.$config = config;
app.config.globalProperties.$tStore = StoreHelper;

app.use(router);
app.use(pinia);
app.use(vuetify);
// pageTrackerExcludedRoutes は実行時サポートあり。vue-gtag 2.1.2 の型定義に未記載のためキャスト
const gtagOptions = {
  config: { id: config.analyticsTrackingId },
  // 朝小詳細は署名付きS3 URLがパスに入るため、自動計測を除外し従来形式の page_path を明示送信する
  pageTrackerExcludedRoutes: ['AsagakuDetail'],
} as PluginOptions;
app.use(VueGtag, gtagOptions, router);

app.mount('#app');
